// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayoutDefinitionServiceDto
 */
export interface IPayoutDefinitionServiceDto {
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionServiceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionServiceDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IPayoutDefinitionServiceDto interface.
 */
export function instanceOfIPayoutDefinitionServiceDto(value: object): value is IPayoutDefinitionServiceDto {
    return true;
}

export function IPayoutDefinitionServiceDtoFromJSON(json: any): IPayoutDefinitionServiceDto {
    return IPayoutDefinitionServiceDtoFromJSONTyped(json, false);
}

export function IPayoutDefinitionServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayoutDefinitionServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IPayoutDefinitionServiceDtoToJSON(json: any): IPayoutDefinitionServiceDto {
    return IPayoutDefinitionServiceDtoToJSONTyped(json, false);
}

export function IPayoutDefinitionServiceDtoToJSONTyped(value?: IPayoutDefinitionServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

